import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./KeyFeatures.css";
const data = [
  {
    id: 1,
    img: "./images/tradetron1.png",
    title: "Strategy Building Wizard",
  },
  { id: 2, img: "./images/tradetron2.png", title: "Execution Algos" },
  { id: 3, img: "./images/tradetron3.png", title: "Backtesting Engine" },
  { id: 4, img: "./images/position-builder.png", title: "Position Builder" },
  { id: 5, img: "./images/earn-strategy.png", title: "Earn by listing your strategy" },
  { id: 6, img: "./images/nocoding.png", title: "Make Algo strategy with  no coding" },
  { id: 7, img: "./images/multiple-execution.png", title: "Multiple Execution types" },
  { id: 6, img: "./images/multiple-asset-classes.png", title: "Multiple asset classes" },
  { id: 6, img: "./images/allow-others.png", title: "Allow others to duplicate your strategy" },
];
function KeyFeatures() {
  return (
    <>
      <section className="key-features-block">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }} lg={{ span: 10, offset: 1 }}>
              <h3>Key Features</h3>
              <ul>
                {data.map((data, i) => {
                  return (
                    <li key={i}>
                       <div className="tradetronkey_group">
                        <div className="tradetronkey_imgpanel">
                          <img src={data.img} alt="img" />
                        </div>
                        <p>{data.title}</p>
                      </div>                      
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default KeyFeatures;
